import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useModalQueryParam from 'hooks/useModalQueryParam';
import Flex, { Box } from 'components/Flex';
import Button from 'components/Button';
import Alert, { AlertTypes } from 'components/Alert';
import Stack from 'components/Stack';
import Heading from 'components/Heading';
import { useDisconnectMyCalendar } from './hooks/useDisconnectMyCalendar';
import { linkMyCalendar } from './utils';
import DisconnectConfirmationModal from './DisconnectConfirmationModal';
import CalendarStatus from './CalendarStatus';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function CalendarDeAuthorisedContent(_ref) {
  var settings = _ref.settings;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useModalQueryParam = useModalQueryParam('disconnect-calendar'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasDisconnectConfirmationModal = _useModalQueryParam2[0],
    toggleDisconnectConfirmationModal = _useModalQueryParam2[1];
  var _useDisconnectMyCalen = useDisconnectMyCalendar({
      showAlert: false
    }),
    disconnectMyCalendar = _useDisconnectMyCalen.disconnectMyCalendar,
    isDisconnectLoading = _useDisconnectMyCalen.isLoading;
  var provider = settings.provider;
  var isGoogleCalendar = provider === 'google';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "m",
      children: [/*#__PURE__*/_jsx(CalendarStatus, {
        status: "fail",
        translationKey: isGoogleCalendar ? 'state_google_calendar_deauthorised' : 'state_microsoft_calendar_deauthorised'
      }), /*#__PURE__*/_jsx(Alert, {
        type: AlertTypes.FAIL,
        children: t('alert_calendar_deauthorised_info')
      }), /*#__PURE__*/_jsx(Alert, {
        type: AlertTypes.FAIL,
        children: t('alert_calendar_deauthorised_helix_behaviour_info')
      }), /*#__PURE__*/_jsx(Heading, {
        as: "h3",
        size: "small",
        children: t('auto_join_settings_deauthorised_options_title')
      }), /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Box, {
          grow: true,
          shrink: true,
          children: t('auto_join_settings_deauthorised_options_reauthorise')
        }), /*#__PURE__*/_jsx(Box, {
          ml: "s",
          children: /*#__PURE__*/_jsx(Button, {
            size: "medium",
            variant: "important",
            onClick: function onClick() {
              return linkMyCalendar(provider, 'reauthorise');
            },
            children: t('actions_reauthorise')
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Box, {
          grow: true,
          shrink: true,
          children: t('auto_join_settings_deauthorised_options_disconnect')
        }), /*#__PURE__*/_jsx(Box, {
          ml: "s",
          children: /*#__PURE__*/_jsx(Button, {
            size: "medium",
            variant: "default",
            onClick: function onClick() {
              return disconnectMyCalendar(provider);
            },
            isLoading: isDisconnectLoading,
            children: t('actions_disconnect')
          })
        })]
      })]
    }), hasDisconnectConfirmationModal && /*#__PURE__*/_jsx(DisconnectConfirmationModal, {
      onClose: toggleDisconnectConfirmationModal,
      provider: provider
    })]
  });
}
export default CalendarDeAuthorisedContent;